var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, ViewChild } from '@angular/core';
import { appModuleAnimation } from '../../animations/routerTransition';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { finalize } from 'rxjs/operators';
import { SampleType } from '../shared/sample-type';
var RawHistoryDataComponent = /** @class */ (function (_super) {
    __extends(RawHistoryDataComponent, _super);
    function RawHistoryDataComponent(injector, fBoxHistoryDataService, dataTypeService) {
        var _this = _super.call(this, injector) || this;
        _this.fBoxHistoryDataService = fBoxHistoryDataService;
        _this.dataTypeService = dataTypeService;
        return _this;
    }
    RawHistoryDataComponent.prototype.ngAfterViewInit = function () {
        this.alreadyAfterViewInit = true;
        this.loadFBoxHistoryData();
    };
    RawHistoryDataComponent.prototype.ngOnChanges = function (_changes) {
        if (this.alreadyAfterViewInit) {
            this.loadFBoxHistoryData();
        }
    };
    RawHistoryDataComponent.prototype.loadFBoxHistoryData = function (event) {
        var _this = this;
        this.primengTableHelper.showDelayLoadingIndicator();
        this.fBoxHistoryDataService.getFBoxHistoryDataList(this.dataSourceId, this.primengTableHelper.getSorting(this.dataTable), this.primengTableHelper.getMaxResultCount(this.paginator, event), this.primengTableHelper.getSkipCount(this.paginator, event)).pipe(finalize(function () { return _this.primengTableHelper.hideLoadingIndicator(); }))
            .subscribe(function (result) {
            _this.primengTableHelper.requestCompleted = true;
            _this.primengTableHelper.totalRecordsCount = result.totalCount;
            _this.loadForEachChannel(result.items);
        });
    };
    RawHistoryDataComponent.prototype.loadForEachChannel = function (items) {
        var array = [];
        items.map(function (item) { return (item.fBoxHistoryChannels || []).map(function (channel, index) {
            array.push({
                item: item,
                channel: channel,
                shouldShow: index === 0,
                expand: true,
                rowspan: item.fBoxHistoryChannels && item.fBoxHistoryChannels.length || 1,
            });
        }); });
        this.primengTableHelper.records = array;
    };
    RawHistoryDataComponent.prototype.rowspan = function (record) {
        return record.expand ? record.rowspan : 1;
    };
    RawHistoryDataComponent.prototype.toggleRow = function (record, event) {
        record.expand = !record.expand;
        var $tr = $(event.target).parent().parent();
        if (!record.expand) {
            $tr.nextAll().slice(0, record.rowspan - 1).hide();
            return;
        }
        $tr.nextAll().slice(0, record.rowspan - 1).show();
    };
    RawHistoryDataComponent.prototype.formatSampleType = function (sampleType, recordingPeriod) {
        var sampleTypeResult = '';
        if (sampleType === SampleType.Cycle) {
            sampleTypeResult = this.lc('Cycle') + ":" + recordingPeriod + this.lc('Second');
        }
        else if (sampleType === SampleType.Trigger) {
            sampleTypeResult = this.lc('Trigger');
        }
        return sampleTypeResult;
    };
    RawHistoryDataComponent.prototype.formatDataType = function (dataType, bitIndexEnabled) {
        var _this = this;
        return this.dataTypeService.formatDataType(dataType, bitIndexEnabled, function (key) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return _this.lc.apply(_this, [key].concat(args));
        });
    };
    __decorate([
        Input()
    ], RawHistoryDataComponent.prototype, "configureId", void 0);
    __decorate([
        Input()
    ], RawHistoryDataComponent.prototype, "dataSourceId", void 0);
    __decorate([
        ViewChild('dataTable', { static: true })
    ], RawHistoryDataComponent.prototype, "dataTable", void 0);
    __decorate([
        ViewChild('paginator', { static: false })
    ], RawHistoryDataComponent.prototype, "paginator", void 0);
    RawHistoryDataComponent = __decorate([
        Component({
            selector: 'raw-history-data',
            template: " <div class=\"primeng-datatable-container\" [busyIf]=\"primengTableHelper.isLoading\"> <p-table #dataTable (onLazyLoad)=\"loadFBoxHistoryData($event)\" [value]=\"primengTableHelper.records\" rows=\"{{primengTableHelper.defaultRecordsCountPerPage}}\" [paginator]=\"false\" [lazy]=\"true\" scrollable=\"true\" ScrollWidth=\"100%\" responsive=\"primengTableHelper.isResponsive\" resizableColumns=\"primengTableHelper.resizableColumns\"> <ng-template pTemplate=\"header\"> <tr> <th class=\"col-md-1 col-xs-1\"> {{lc('HistoryDataName')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('SampleType')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('Channel')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('Devices')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('DataType')}} </th> <th class=\"col-md-1 col-xs-1\"> {{lc('Address')}} </th> </tr> </ng-template> <ng-template pTemplate=\"body\" let-record let-rowIndex=\"rowIndex\"> <tr> <td *ngIf=\"record.shouldShow\" [attr.rowspan]=\"rowspan(record)\" class=\"col-md-1 col-xs-1\"> <i [ngClass]=\"record.expand || record.rowspan === 1 ? 'fa fa-minus-circle pointer expanded' : 'fa fa-plus-circle pointer unexpanded'\" (click)=\"toggleRow(record, $event)\"></i> {{record.item.name}} </td> <td *ngIf=\"record.shouldShow\" [attr.rowspan]=\"rowspan(record)\" class=\"col-md-1 col-xs-1\"> {{ formatSampleType(record.item.sampleType, record.item.recordingPeriod) }} </td> <td class=\"col-md-1 col-xs-1\"> {{record.channel?.channelName}} </td> <td class=\"col-md-1 col-xs-1\"> {{record.channel?.devAlias}} </td> <td class=\"col-md-1 col-xs-1\"> {{formatDataType(record.channel?.dataType, record.channel?.bitIndexEnabled)}} </td> <td class=\"col-md-1 col-xs-1\"> {{record.channel?.addressDescription}} </td> </tr> </ng-template> </p-table> <div class=\"primeng-no-data\" *ngIf=\"primengTableHelper.totalRecordsCount == 0\"> {{l('NoData')}} </div> <div class=\"primeng-paging-container\"> <p-paginator #paginator [rows]=\"primengTableHelper.defaultRecordsCountPerPage\" (onPageChange)=\"loadFBoxHistoryData($event)\" [totalRecords]=\"primengTableHelper.totalRecordsCount\" [rowsPerPageOptions]=\"primengTableHelper.predefinedRecordsCountPerPage\"> </p-paginator> <span class=\"total-records-count\"> {{l('TotalRecordsCount', primengTableHelper.totalRecordsCount)}} </span> </div> </div> ",
            styles: [".expanded { color: #999; } .unexpanded { color: #3695FF; } .pointer { cursor: pointer; } .primeng-datatable-container{ margin-top: 12px; } "],
            animations: [appModuleAnimation()]
        })
    ], RawHistoryDataComponent);
    return RawHistoryDataComponent;
}(ConfigureComponentBase));
export { RawHistoryDataComponent };
